import { writable } from 'svelte/store'

export const changeCount = writable(0)
